import { PopupSlideEnum } from './../../../enums/popupTypeEnum';
import { useEffect, useRef, useState } from 'react';
import { PopupModel } from '../../../models/popup';
import { generateImageFileNameWithRandomName } from '../../../utils/generateImageFileName';
import moment from 'moment';
import { PopupTypeEnum } from '../../../enums/popupTypeEnum';
import { IMAGE_POPUP_ROOT_URL } from '../../../constants/imageUrl';
import { useTranslation } from 'react-i18next';
import { ProductMerchantModel } from '../../../models/productMerchant';
import { handleGetProductByItemCode } from '../../../utils/getProductByItemCodeFunction';
import { SelectChangeEvent } from '@mui/material';
import { CategoriesModel } from '../../../models/categories';
import { DivisionModel } from '../../../models/division';
import { MainGroupModel } from '../../../models/mainGroup';
import { getMainGroupByMerchantId } from '../../../services/mainGroup';
import { SubCategoryModel } from '../../../models/subCategory';
import { createPopupService, updatePopupService } from '../../../services/popup';
import { convertDateStringToString } from '../../../utils/convertDateFormat';
import { getProductMerchantById } from '../../../services/productMerchant';

interface Props {
  selectedData: PopupModel;
  onClose: VoidFunction;
  popupType: PopupTypeEnum;
  onFetchData: Function;
}
interface CategoryMatch {
  mainGroup: MainGroupModel | null;
  division: DivisionModel | null;
  category: CategoriesModel | null;
  subCategory: SubCategoryModel | null;
}
export const usePopUpFormManageControllers = ({ selectedData, onClose, popupType, onFetchData }: Props) => {
  const { t } = useTranslation('global');
  // variables
  const [productData, setProductData] = useState<ProductMerchantModel[]>([]);
  const [mainGroupData, setMainGroupData] = useState<MainGroupModel[]>([]);
  const [divisionData, setDivisionData] = useState<DivisionModel[]>([]);
  const [categoriesData, setCategoriesData] = useState<CategoriesModel[]>([]);
  const [subCategoryData, setSubCategoryData] = useState<SubCategoryModel[]>([]);
  const [selectedTypePopup, setSelectedTypePopup] = useState<string>('');
  const [selectedPopupType, setSelectedPopupType] = useState<PopupTypeEnum>(PopupTypeEnum.LANDING_PAGE);

  const [imageFile, setImageFile] = useState<any>(null);
  const [imageToShow, setImageToShow] = useState<any>(null);
  const [selectedMerchantValue, setSelectedMerchantValue] = useState<string>('');
  const [selectedTagPromotion, setSelectedTagPromotion] = useState<string>('');
  const [selectedProductValue, setSelectedProductValue] = useState<string>(null!);
  const [selectedMainCategory, setSelectedMainCategory] = useState<string>('');
  const [selectedDivision, setSelectedDivision] = useState<string>('');
  const [selectedCategories, setSelectedCategories] = useState<string>('');
  const [selectedSubCategory, setSelectedSubCategory] = useState<string>('');

  const startDateRef = useRef<HTMLInputElement>(null!);
  const endDateRef = useRef<HTMLInputElement>(null!);
  const promotionTypeRef = useRef<HTMLInputElement>(null!);
  const promotionTagRef = useRef<HTMLInputElement>(null!);
  const merchantIdRef = useRef<HTMLInputElement>(null!);
  const quantityProductRef = useRef<HTMLInputElement>(null!);
  const itemProductCodeRef = useRef<HTMLInputElement>(null!);

  const [errorMessage, setErrorMessage] = useState<string>('');
  const [errorMessageSearchProduct, setErrorMessageSearchProduct] = useState<string>('');

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [loadingCategories, setLoadingCategories] = useState<boolean>(false);

  // functions

  const handleGetCategories = async () => {
    try {
      setLoadingCategories(true);
      const resCat = await getMainGroupByMerchantId({ merchantId: selectedMerchantValue });
      setMainGroupData(resCat);
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert(t('validatr_promotion.Server error please try again'));
      }
    } finally {
      setLoadingCategories(false);
    }
  };

  const handleGetProductMerchant = async () => {
    try {
      if (selectedData) {
        const res = await getProductMerchantById(selectedData?.productId, selectedMerchantValue);
        setProductData(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetProductCode = async (): Promise<void> =>
    handleGetProductByItemCode(
      itemProductCodeRef.current.value,
      setProductData,
      setErrorMessageSearchProduct
  );

  const handleSelectImage = (e: any) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    setImageFile(file);
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImageToShow(reader.result);
      }
    };
    reader.readAsDataURL(file);
    setImageFile(file);
  };

  const handleFormValidate = (): boolean => {
    const getStartDate = new Date(startDateRef.current.value);
    const getEndDate = new Date(endDateRef.current.value);
    const today = new Date().setHours(0, 0, 0, 0);

    if (getStartDate >= getEndDate) {
      const errorMessage = t('popup_page.Start date must be less than End date');
      setErrorMessage(errorMessage);
      return false;
    }
    if (getEndDate.setHours(0, 0, 0, 0) < today) {
      const errorMessage = t('popup_page.End date must be greater or equal to today');
      setErrorMessage(errorMessage);
      return false;
    }

    if (!selectedData && !imageFile) {
      const errorMessage = t('popup_page.Please select image');
      setErrorMessage(errorMessage);
      return false;
    }
    if (!selectedTypePopup) {
      const errorMessage = t('popup_page.Please select popup type');
      setErrorMessage(errorMessage);
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleCreatePopupData = async () => {
    try {
      setLoadingSubmit(true);
      const startDateValue = startDateRef.current.value;
      const endDateValue = endDateRef.current.value;
      const currentDate = moment(new Date()).format('MM/DD/yyyy');
      const startDate = moment(startDateValue).format('MM/DD/yyyy');
      const isActive = currentDate === startDate || currentDate > startDate;

      const formData = {
        merchant: selectedMerchantValue,
        image: generateImageFileNameWithRandomName(imageFile),
        startDate: moment(new Date(startDateValue)).format('MM/DD/yyyy'),
        endDate: moment(new Date(endDateValue)).format('MM/DD/yyyy'),
        type: popupType,
        productId: selectedProductValue,
        promotionTagId: selectedTagPromotion,
        subCategoryId: selectedSubCategory,
        isActive,
      };
      await createPopupService(formData);
      await onFetchData();
      onClose();
    } catch (error: any) {
      setErrorMessage(
        error.response.data.message ?? t('popup_page.Server error please try again later')
      );
    } finally {
      setLoadingSubmit(false);
      setOpenConfirmDialog(false);
    }
  };

  const handleUpdatePopupData = async () => {
    try {
      setLoadingSubmit(true);
      const startDateValue = startDateRef.current.value;
      const endDateValue = endDateRef.current.value;
      const formData: any = {
        startDate: moment(new Date(startDateValue)).format('MM/DD/yyyy'),
        endDate: moment(new Date(endDateValue)).subtract(1, 'days').format('MM/DD/yyyy'),
      };
      if (imageFile) {
        formData.image = generateImageFileNameWithRandomName(imageFile);
      }
      await updatePopupService(formData, selectedData?.id);
      await onFetchData();
      onClose();
    } catch (error: any) {
      setErrorMessage(
        error.response.data.message ?? t('popup_page.Server error please try again later')
      );
    } finally {
      setLoadingSubmit(false);
      setOpenConfirmDialog(false);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (handleFormValidate()) {
      setOpenConfirmDialog(true);
    }
  };

  const handleConfirmDialog = () => {
    if (selectedData) {
      handleUpdatePopupData();
    } else {
      handleCreatePopupData();
    }
  };

  const handleSelectedPopupType = (event: SelectChangeEvent<string>) => { setSelectedTypePopup(event.target.value)};
  const handleSelectTagPromotion = (event: SelectChangeEvent<string>) => { setSelectedTagPromotion(event.target.value)};
  const handleSelectedMerchant = (event: SelectChangeEvent<string>) => { setSelectedMerchantValue(event.target.value as string)};

  const handleSelectMainGroup = (event: SelectChangeEvent<string>) => { setSelectedMainCategory(event.target.value as string)};
  const handleSelectDivision = (event: SelectChangeEvent<string>) => { setSelectedDivision(event.target.value as string)};
  const handleSelectCategories = (event: SelectChangeEvent<string>) => { setSelectedCategories(event.target.value as string)};
  const handleSelectSubCategory = (event: SelectChangeEvent<string>) => { setSelectedSubCategory(event.target.value as string)};

  const findCategoryDataBySubCategoryId = (
    mainGroupData: MainGroupModel[],
    targetSubCategoryId: string
  ): CategoryMatch => {
    let result: CategoryMatch = {
      mainGroup: null,
      division: null,
      category: null,
      subCategory: null,
    };

    // Traverse through main groups
    for (const mainGroup of mainGroupData) {
      if (!mainGroup.division_name) continue;

      // Traverse through divisions
      for (const division of mainGroup.division_name) {
        if (!division.product_category) continue;

        // Traverse through categories
        for (const category of division.product_category) {
          if (!category.product_sub_category) continue;

          // Find matching subcategory
          const foundSubCategory = category?.product_sub_category.find(
            (sub) => sub.id === targetSubCategoryId
          );

          if (foundSubCategory) {
            result = {
              mainGroup: mainGroup,
              division: division,
              category: category,
              subCategory: foundSubCategory,
            };
            // Return immediately when match is found
            return result;
          }
        }
      }
    }
    return result;
  };

  useEffect(() => {
    if (!selectedMainCategory) return;
    const mainData = mainGroupData?.find(
      (item: MainGroupModel) => item?.id === selectedMainCategory
    );

    const divisionData = mainData?.division_name;
    setSubCategoryData([]);
    setCategoriesData([]);
    setDivisionData([]);

    if (divisionData) {
      setSubCategoryData([]);
      setCategoriesData([]);
      setDivisionData(divisionData);
      if (!selectedDivision) return;
      const categoriesData = divisionData?.find(
        (item: DivisionModel) => item?.id === selectedDivision
      )?.product_category;
      if (categoriesData) {
        setSubCategoryData([]);
        setCategoriesData(categoriesData);
        if (!selectedCategories) return;
        const selectedCategory = categoriesData?.find(
          (item: CategoriesModel) => item?.id === selectedCategories
        );
        const getSubCategoryData = selectedCategory?.product_sub_category;
        if (getSubCategoryData) {
          setSubCategoryData(getSubCategoryData);
        }
      }
    }
  }, [selectedMainCategory, mainGroupData, selectedDivision, selectedCategories]);

  useEffect(() => {
    handleGetCategories();
    if (selectedData?.productId) {
      handleGetProductMerchant();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMerchantValue]);

  useEffect(() => {
    if (selectedData) {
      startDateRef.current.value = convertDateStringToString(selectedData?.startDate);
      endDateRef.current.value = convertDateStringToString(selectedData?.endDate);

      setImageToShow(IMAGE_POPUP_ROOT_URL + selectedData?.image?.url);
      setSelectedTagPromotion(selectedData?.promotionTagId);
      setSelectedMerchantValue(selectedData?.merchant);
      setSelectedPopupType(selectedData?.type as PopupTypeEnum);

      setSelectedTypePopup((prevState) => {
        if (selectedData?.promotionTagId) {
          return PopupSlideEnum.PROMOTION_FLASH_SALE;
        } else if (selectedData?.subCategoryId) {
          return PopupSlideEnum.CATEGORY;
        } else if (selectedData?.productId) {
          return PopupSlideEnum.PRODUCT_DETAIL;
        } else return prevState;
      });

      if (selectedData?.subCategoryId && mainGroupData) {
        const foundData = findCategoryDataBySubCategoryId(
          mainGroupData,
          selectedData.subCategoryId
        );

        if (foundData) {
          if (foundData.mainGroup?.id) {
            setSelectedMainCategory(foundData.mainGroup.id);
          }
          if (foundData.division?.id) {
            setSelectedDivision(foundData.division.id);
          }
          if (foundData.category?.id) {
            setSelectedCategories(foundData.category.id);
          }
          if (foundData.subCategory?.id) {
            setSelectedSubCategory(foundData.subCategory?.id);
          }
        } else {
          console.warn(
            'No matching category data found for subCategoryId:',
            selectedData.subCategoryId
          );
        }
      }

      if (selectedData?.productId) {
        const foundProduct = productData?.find((item) => item?.id === selectedData?.productId);
        if (foundProduct) {
          setSelectedProductValue(foundProduct?.id);
          itemProductCodeRef.current.value = foundProduct?.price?.itemcode;
        } else {
          console.warn('Product not found for the given productId:', selectedData?.productId);
          setSelectedProductValue('');
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedData, mainGroupData, productData]);

  console.log(selectedData);
  
  
  return {
    startDateRef,
    endDateRef,
    imageToShow,
    errorMessage,
    loadingSubmit,
    openConfirmDialog,
    promotionTypeRef,
    promotionTagRef,
    merchantIdRef,
    quantityProductRef,
    productData,
    errorMessageSearchProduct,
    subCategoryData,
    divisionData,
    categoriesData,
    loadingCategories,
    mainGroupData,
    itemProductCodeRef,
    selectedData,
    selectedMerchantValue,
    selectedTagPromotion,
    selectedProductValue,
    selectedPopupType,
    selectedSubCategory,
    selectedMainCategory,
    selectedDivision,
    selectedCategories,
    selectedTypePopup,
    handleSelectImage,
    handleSubmit,
    handleConfirmDialog,
    handleSelectedMerchant,
    handleGetProductCode,
    handleSelectTagPromotion,
    handleSelectSubCategory,
    handleSelectMainGroup,
    handleSelectDivision,
    handleSelectCategories,
    handleSelectedPopupType,
    handleSelectPopupType: (value: PopupTypeEnum) => setSelectedPopupType(value),
    handleSetOpenConfirmDialog: (newValue: boolean) => setOpenConfirmDialog(newValue),
    handleSelectedProduct: (event: SelectChangeEvent<string>) => setSelectedProductValue(event.target.value),
  };
};
